export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_ASYNC = 'GET_NOTIFICATIONS_ASYNC';

export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_ASYNC = 'DELETE_NOTIFICATION_ASYNC';

export const ACCEPT_NOTIFICATION_COLLABORATE = 'ACCEPT_NOTIFICATION_COLLABORATE';

export const CLEAR_ALL_NOTIFICATIONS = 'CLEAR_ALL_NOTIFICATIONS';
export const CLEAR_ALL_NOTIFICATIONS_ASYNC = 'CLEAR_ALL_NOTIFICATIONS_ASYNC'